import React from "react";
import styled from "styled-components";
import { off_white } from "../../../../helperFunctions/styledComponents";

interface PendingAwardUpdatesProps {
  invalidApprovalProcess: boolean;
  pendingRequestCount: number;
  resetPendingRequests: boolean;
  setResetPendingRequests: (boolean) => void;
}

const StyledTabWrapper = styled.div`
  padding: 20px 30px;
  background-color: ${off_white};
  border-radius: 4px;
  margin-top: 10px;

  p {
    text-align: center;
  }
`;

const StyledParagraphWrapper = styled.p`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  input[type="radio"] {
    vertical-align: middle;
    margin-top: 0px;
  }
`;

const StyledSmallWrapper = styled.small`
  margin-left: 5px;
`;

const StyledToolTip = styled.span`
  margin: 0 0 3px 5px;
`;

const PendingAwardUpdates = (props: PendingAwardUpdatesProps) => {
  const headerText =
    props.pendingRequestCount !== 1
      ? `There are ${props.pendingRequestCount} pending awards that are waiting to be reviewed`
      : `There is ${props.pendingRequestCount} pending award that is waiting to be reviewed`;

  const awardOrAwards = props.pendingRequestCount !== 1 ? "awards" : "award";

  return (
    <StyledTabWrapper>
      <p>{headerText}</p>
      <StyledParagraphWrapper>
        <label>
          <input
            type="radio"
            name="reset_pending"
            value="false"
            checked={!props.resetPendingRequests}
            disabled={props.invalidApprovalProcess}
            onChange={() => props.setResetPendingRequests(false)}
          />
          <StyledSmallWrapper>
            Do not apply these updates to the pending {awardOrAwards}.
          </StyledSmallWrapper>
        </label>
        <StyledToolTip
          data-toggle="tooltip"
          title="Any pending awards will complete their current approval process."
        >
          <i className="fas fa-info-circle"></i>
        </StyledToolTip>
      </StyledParagraphWrapper>
      <StyledParagraphWrapper>
        <label>
          <input
            type="radio"
            name="reset_pending"
            value="true"
            checked={props.resetPendingRequests}
            onChange={() => props.setResetPendingRequests(true)}
          />
          <StyledSmallWrapper>
            Apply these updates to the pending {awardOrAwards} and restart the
            approval process.
          </StyledSmallWrapper>
        </label>
        <StyledToolTip
          data-toggle="tooltip"
          title="If an approver already reviewed an award, they will be asked to review the award again."
        >
          <i className="fas fa-info-circle"></i>
        </StyledToolTip>
      </StyledParagraphWrapper>
    </StyledTabWrapper>
  );
};

export default PendingAwardUpdates;
